import { render } from "./struct.vue?vue&type=template&id=f3e91ba2"
import script from "./struct.vue?vue&type=script&lang=js"
export * from "./struct.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__